<template>
 <svg :style="style" width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
<g id="&#229;&#164;&#167;&#229;&#176;&#143;&#231;&#177;&#187;&#229;&#158;&#139;=&#229;&#164;&#167;40, &#231;&#167;&#145;&#229;&#174;&#164;&#229;&#144;&#141;&#231;&#167;&#176;=&#232;&#130;&#157;&#232;&#131;&#134;&#229;&#164;&#150;&#231;&#167;&#145;" clip-path="url(#clip0_2100_17536)">
<path id="Vector" d="M39.2456 12.6049C39.2456 12.6049 28.4282 8.65831 25.2614 12.7695C25.2614 12.7695 23.1213 16.7161 26.4527 20.8707C26.4527 20.8707 27.8087 22.7205 32.1279 19.0209C32.1279 19.0209 37.3914 14.4158 38.7907 14.4158C38.7951 14.4158 41.7149 13.428 39.2456 12.6049ZM22.9177 13.9609C22.9177 13.9609 23.7798 13.0988 22.8354 12.5226C22.8354 12.5226 13.3826 8.29441 7.90669 13.8396C6.96661 15.0526 3.99908 18.1154 7.70308 26.4245C7.70308 26.4245 10.1724 33.291 11.8576 34.7336C11.8576 34.7336 12.7631 35.1842 13.4215 33.499C13.4215 33.499 16.9566 25.5624 23.9487 23.0108C23.9487 23.0108 26.2534 21.3256 23.2512 18.1588C23.2469 18.1544 21.8519 16.3869 22.9177 13.9609Z" fill="white"/>
</g>
<defs>
<clipPath id="clip0_2100_17536">
<rect width="40" height="40" fill="white"/>
</clipPath>
</defs>
</svg>



</template>

<script>
export default {
  name: 'icon-gzwk',
  props: {
    fontSize: {
      type: String,
      default: '18px'
    },
    color: {
      type: String,
      default: 'white'
    }
  },
  data() {
    return {
      style: {
        width: '1em',
        height: '1em',
        'vertical-align': 'middle',
        fill: 'currentColor',
        overflow: 'hidden',
        cursor: 'pointer',
        'font-size': this.fontSize
      }
    }
  }
}
</script>